import { spacings } from '../themes/spacings';
export const borderRadiuses = {
    xxs: spacings['spacing-xxs'],
    xs: spacings['spacing-xs'],
    s: spacings['spacing-s'],
    m: spacings['spacing-m'],
    l: spacings['spacing-l'],
    xl: spacings['spacing-xl'],
    xxl: spacings['spacing-xxl'],
};
